import React from 'react'

export default function RegisterProductUnitFormStyle() {
  return (
    <React.Fragment>
      <style jsx='true'>
      {`
        /* MODAL FORM this is for other price input form */
        .modal-content-container.unit-form { margin: 5% auto; }
        /* MODAL FORM END */

        /*
        #add-unit-form {
          height: 100%;
          overflow: auto;
        }
        */

        #add-unit-form {
          display: flex;
          flex-direction: column;
          height: 100%;
        }

        .add-unit-form {
          height: 100%;
          overflow: auto;
        }

        .add-unit-form * {
          font-size: 17px;
        }

        .button-unit {
          display: flex;
          justify-content: flex-end;
          padding: 10px;
        }
        .button-unit button {
          margin-left: 2px;
          margin-top: 5px;
        }

        .item-error-text {
          font-size: 1rem;
          display: flex;
          flex: 2;
          margin: auto;
        }

        .add-unit-form .form-group {
          display: flex;
        }

        .add-unit-form .form-group input[type='text'] {
          font-size: 17px;
          margin-right: 0;
        }

        .add-unit-form .form-group .input-container {
          /*position: relative;*/
          display: flex;
          flex-direction: column;
          font-size: 17px;
        }

        .add-unit-form .form-group label {
          flex: 5;
        }

        .add-unit-form
        .form-group select,
          input,
          #item-unit-vatable-container,
          #item-unit-fractional-container,
          #item-unit-status-container  {
          padding: 5px;
          border-radius: 3px;
          border: solid 1px lightblue;
        }

        .acl-container {
          position: relative;
        }

        /* Vatable begin */
        .add-unit-form #item-unit-vatable-container {
          display: flex;
        }
        .add-unit-form #item-unit-vatable-yes-container {
          flex: 1;
        }
        .add-unit-form #item-unit-vatable-yes-container * {
          margin-right: 10px;
        }
        .add-unit-form #item-unit-vatable-no-container {
          flex: 4;
        }
        .add-unit-form #item-unit-vatable-no-container * {
          margin-right: 10px;
        }
        /* Vatable end */

        /* Fractional Quantity begin */
        .add-unit-form #item-unit-fractional-container {
          display: flex;
        }
        .add-unit-form #item-unit-fractional-yes-container  {
          flex: 1;
        }
        .add-unit-form #item-unit-fractional-yes-container * {
          margin-right: 10px;
        }
        .add-unit-form #item-unit-fractional-no-container {
          flex: 4;
        }
        .add-unit-form #item-unit-fractional-no-container * {
          margin-right: 10px;
        }
        /* Fractional Quantity end */

        /* Status begin */
        .add-unit-form #item-unit-status-container {
          display: flex;
        }
        .add-unit-form #unit-status-active-container {
          flex: 1;
        }
        .add-unit-form #unit-status-active-container * {
          margin-right: 10px;
        }
        .add-unit-form #unit-status-inactive-container {
          flex: 4;
        }
        .add-unit-form #unit-status-inactive-container * {
          margin-right: 10px;
        }
        /* Status end */

        .modal-close-adding-unit-btn {
          color: #CCC;
          float: right;
        }
      `}
      </style>
    </React.Fragment>
  )
}
